import React, { useState } from 'react';
import Form from '../Form';

import EditParamsList from '../EditParamsList';
import FormOutput from './FormOutput';
import { useFormContext } from '../FormContext';


const FormContainer = ( { editView, handleEditViewToggle } ) => {
    const [finalUrl, setFinalUrl] = useState('');
    const [urlIsComplete, setUrlIsComplete] = useState(false);

    const formContext = useFormContext();

    const callbackFunction = (childData, { warnings = [], params = {} } = {}) => {
        // Complete means: every required field (per the field config) has a
        // value, and buildUrl didn't have to flag a missing base URL.
        const requiredFieldNames = formContext.formData
            .filter(field => field.isRequired)
            .map(field => field.name);

        const hasAllRequired = requiredFieldNames.every(name => Boolean(params[name]));
        const hasMissingBaseUrl = warnings.includes('Missing base URL');

        setFinalUrl(childData);
        setUrlIsComplete(hasAllRequired && !hasMissingBaseUrl);
    }
    /*
    <div className='form-footer'>
        <button className={editView ? 'btn btn-finish toggle-view' : 'btn btn-customise toggle-view'} onClick={handleEditViewToggle}>{editView ? 'Finish' : 'Customise'}</button>
    </div>*/

    return (
        <div className={`form-container-wrapper ${editView ? 'edit-view' : 'param-view'}`}>
            <div className='form-container param-view'>
                <div className='form-header'>
                    <h5>Add some sweet params</h5>
                </div>
                <Form parentCallback={callbackFunction} />
                <FormOutput isVisible={urlIsComplete} output={finalUrl} />

                <div className='form-footer'></div>
            </div>
            <div className='form-container edit-view'>
                <div className='form-header'>
                    <h5>Customise your params</h5>
                </div>
                <EditParamsList /> 
                <div className='form-footer'></div>
            </div>
        </div>
    )
}

export default FormContainer;
